
import { useState } from 'react';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      quote: "Working with this recruitment team has transformed our hiring process. They understood our company culture and delivered exceptional candidates who have become key members of our organization. Their professionalism and dedication are unmatched.",
      name: "Sarah Mitchell",
      position: "HR Director",
      company: "TechVision Solutions",
      image: "https://readdy.ai/api/search-image?query=professional%20confident%20female%20HR%20director%20in%20modern%20office%20wearing%20business%20attire%20with%20warm%20smile%20and%20approachable%20demeanor%20corporate%20headshot%20photography&width=200&height=200&seq=testimonial-001&orientation=squarish"
    },
    {
      quote: "The level of service and attention to detail exceeded our expectations. They not only found us the perfect candidates but also provided valuable insights into market trends and salary benchmarks. A true partner in our growth journey.",
      name: "Michael Chen",
      position: "CEO",
      company: "InnovateCorp",
      image: "https://readdy.ai/api/search-image?query=successful%20asian%20male%20CEO%20executive%20in%20professional%20business%20suit%20confident%20leadership%20portrait%20modern%20corporate%20photography%20with%20natural%20lighting&width=200&height=200&seq=testimonial-002&orientation=squarish"
    },
    {
      quote: "As a job seeker, I was impressed by their personalized approach. They took time to understand my career goals and matched me with opportunities that aligned perfectly with my aspirations. I found my dream job thanks to their expertise.",
      name: "Emily Rodriguez",
      position: "Senior Software Engineer",
      company: "CloudTech Industries",
      image: "https://readdy.ai/api/search-image?query=professional%20latina%20female%20software%20engineer%20in%20casual%20business%20attire%20friendly%20smile%20technology%20professional%20headshot%20with%20modern%20office%20background&width=200&height=200&seq=testimonial-003&orientation=squarish"
    }
  ];

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            What Our Clients Say
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Trusted by leading companies and professionals worldwide
          </p>
        </div>

        {/* Testimonial Card */}
        <div className="max-w-5xl mx-auto">
          <div className="bg-gray-50 rounded-2xl p-8 lg:p-12 shadow-lg">
            <div className="flex flex-col lg:flex-row items-center gap-8">
              {/* Image */}
              <div className="flex-shrink-0">
                <img
                  src={testimonials[currentIndex].image}
                  alt={testimonials[currentIndex].name}
                  className="w-32 h-32 lg:w-40 lg:h-40 rounded-full object-cover border-4 border-white shadow-lg"
                />
              </div>

              {/* Content */}
              <div className="flex-1 text-center lg:text-left">
                <div className="mb-6">
                  <i className="ri-double-quotes-l text-5xl text-teal-600 opacity-50"></i>
                </div>
                <p className="text-xl lg:text-2xl text-gray-700 italic leading-relaxed mb-6">
                  {testimonials[currentIndex].quote}
                </p>
                <div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {testimonials[currentIndex].name}
                  </h4>
                  <p className="text-gray-600">
                    {testimonials[currentIndex].position} at {testimonials[currentIndex].company}
                  </p>
                </div>
              </div>
            </div>

            {/* Navigation */}
            <div className="flex items-center justify-center lg:justify-start gap-4 mt-8">
              <button
                onClick={handlePrevious}
                className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-gray-300 text-gray-600 hover:border-teal-600 hover:text-teal-600 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line text-xl"></i>
              </button>
              <button
                onClick={handleNext}
                className="w-12 h-12 flex items-center justify-center rounded-full bg-teal-600 text-white hover:bg-teal-700 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
              
              {/* Dots */}
              <div className="flex items-center gap-2 ml-4">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentIndex(index)}
                    className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                      index === currentIndex ? 'bg-teal-600 w-8' : 'bg-gray-300'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
